import types from "../types";

export function getLogs() {
  return async (dispatch) => {
    return dispatch({
      type: types.GET,
      payload: {
        request: {
          url: "logs/",
          method: "GET",
        },
      },
    });
  };
}